<template>
	<div class="editProfile">
		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<h1>{{ $t('profile') }}</h1>
					<div class="row d-flex flex-col sm:flex-row">
						<ProfileImage
							v-model="profile.photo"
							@uploadPhoto="togglePhoto"
							class="mb-5 mr-0 sm:mr-8"
						/>
						<div class="vx-row mt-10 sm:mt-0">
							<div class="vx-col w-full lg:w-1/2">
								<div class="vx-row items-end">
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
												  v-model="profile.first_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('name') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
												  v-model="profile.last_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('surname') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-input label="Email" name="email" v-validate="'required|email|min:3'"
												  v-model="profile.email"/>
										<span
											:class="{ 'text-transparent': !errors.first('email') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-input :label="$t('emailForPayment')" name="emailRent"
												  v-validate="'required|email|min:3'"
												  v-model="profile.email_payment"/>
										<span
											:class="{ 'text-transparent': !errors.first('emailRent') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-input
											:label="$t('nickname')"
											name="nickname"
											v-validate="'required|min:3'"
											v-model="profile.username"
										/>
										<span
											:class="{ 'text-transparent': !errors.first('nickname') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vx-input-group>
											<div class="vs-component vs-con-input-label vs-input vs-input-primary">
												<label class="vs-input--label">{{ $t('birthDate') }}</label>
												<div class="vs-con-input">
												</div>
												<vs-datepicker
													v-model="profile.birth_date"
													format="dd.MM.yyyy"
													v-validate="'required'"
													name="date"
												/>
											</div>
											<span
												:class="{ 'text-transparent': !errors.first('date') }"
												class="text-danger text-sm"
											>
												{{ $t('fieldFilledIncorrect') }}
											</span>
										</vx-input-group>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<vs-phone
											:label="$t('phone')"
											name="phone"
											v-validate="'required|min:7|max:14'"
											v-model="profile.phone"
										/>
										<span
											:class="{ 'text-transparent': !errors.first('phone') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('sex') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="profile.gender"
												v-validate="'required'"
												:reduce="country => country.id"
												:options="genders"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:clearable="false"
												label="name"
												name="sex"
												class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('sex') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('country') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="profile.country"
												:reduce="country => country.id"
												:options="countries"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												label="name" v-validate="'required'"
												name="country"
												:clearable="false"
												class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('country') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2 mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('language') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="language"
												v-validate="'required'"
												:options="languages.map(item => ({ id: item.id, [`name_${locale}`]: item.name}))"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												name="lang"
												data
												:label="`name_${locale}`"
												:clearable="false"
												class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('lang') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full md:w-2/3 lg:w-full mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('subjects') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												multiple
												:closeOnSelect="false"
												v-validate="'required'"
												name="subject"
												data
												v-model="profile.subjects"
												:reduce="subjects => subjects.id" label="name"
												:options="subjects"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('subject') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

								</div>
							</div>
							<div class="vx-col w-full lg:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full mb-2">
										<div class="vs-component vs-con-input-label vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('aboutYourself') }}</label>
											<div class="vs-con-input">
											</div>
											<vs-textarea
												v-model="profile.about"
												name="about"
												v-validate="'required|min:3'"
												class="mb-0"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('about') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2  w-full">
										<vx-input-group>
											<vs-password
												:label="$t('password')"
												data-vv-validate-on="blur"
												v-validate="'required|min:6|max:32'"
												type="password"
												name="password"
												v-model="oldpassword"
											/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('password') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/2  w-full">
										<vx-input-group>
											<vs-password
												:label="$t('repeatPassword')"
												data-vv-validate-on="blur"
												v-validate="'required|min:6|max:32'"
												type="password"
												name="repeat-password"
												v-model="newpassword"
											/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('repeat-password') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button class="mr-5" @click="editAuthor">{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">{{ $t('cancel') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileImage from "@/components/ProfileImage";
import notifier from "@/mixins/notifier";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
	name: "EditAuthor",
	mixins: [notifier],
	components: {
		ProfileImage,
		datepicker,
		'v-select': vSelect,
	},
	computed: {
		minDate() {
			return new Date();
		},
		locale() {
			return this.$store.state.locale;
		},
		language: {
			get() {
				this.profile.languages = this.profile.languages || [];

				if(this.profile.languages.length === 0) {
					this.profile.languages.push({id: 1});
				}

				return this.profile.languages[0];
			},
			set(value) {
				this.profile.languages = this.profile.languages || [];

				if(this.profile.languages.length === 0) {
					this.profile.languages.push(value);
				} else {
					this.$set(this.profile.languages, 0, value);
				}
			}
		}
	},
	methods: {
		async togglePhoto(err,file){
			try {
				this.profile.photo = (await this.$http.post('/upload/one', this.$formData({file: file[0]}))).data.data.url;
				this.changePhoto = false;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async editAuthor(){
			try {
				let formData = {};
				for(let key in this.profile) {
					if(key !== "languages") {
						formData[key] = this.profile[key];
					} else {
						formData[key] = this.profile[key][0].id;
					}
				}

				formData.password = this.newpassword !== '' ? this.newpassword : undefined;
				formData.password2 = this.oldpassword !== '' ? this.oldpassword : undefined;
				formData.birth_date = moment(formData.birth_date).format("YYYY-MM-DD HH:MM:ss");

				if(this.newpassword !== '' && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if(this.oldpassword !== '' && this.oldpassword !== null) {
					formData.password2 = this.oldpassword;
				}

				this.newpassword = null;
				this.oldpassword = null;

				let res = await this.$http.post('/admin/author/update/'+this.$route.params.id,formData);
				this.notifySuccess(this.$t('dataIsSaved'));

				this.$router.back();

			}catch (e) {
				this.notifyError(e.message);
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					})
				}
			}
		},
		async removePhoto(){
			try {
				let res = await this.$http.post('/admin/author/delete-photo/'+this.$route.params.id);
				this.notifySuccess(this.$t('dataIsSaved'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	async created () {
		const role = this.$store.state.auth.role;
		const authorId = this.$route.params.id;

		this.profile = 	 (await this.$http.get(`/${role}/author/view/${authorId}`)).data.data;
		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.subjects =  (await this.$http.get(`/settings/get-subjects`)).data.data;

		this.countries = (await this.$http.get('/settings/get-countries')).data.data;
		this.genders =	 (await this.$http.get('/settings/get-genders')).data.data;

		if(this.profile.gender === 0) {
			this.profile.gender = 1
			this.$nextTick(() => this.profile.gender = 0)
		}
	},
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			name: '',
			email: '',
			emailRent: '',
			surname: '',
			date: '',
			phone: '',
			sex: '',
			country: '',
			about: '',
			oldpassword: '',
			newpassword: '',
			lang: [],
			subject: [],

			languages: [],
			subjects: [],
			countries: [],
			genders: [],
			profile: {},
		}
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs-textarea {
	height: 121px;
}


.editProfile {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.65rem;
		width: 2.65rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 20px;
		align-items: center;

		&-text {
			margin-top: 4px;
		}
	}

	.vs-con-input-label {
		width: 100%;
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}

		}
	}

	.photo {
		width: 170px;
		height: 150px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 0 ;
		flex-shrink: 0;
		.con-input-upload,.img-upload{
			width: 100%;
			margin: 0;
			height: 100%;
		}
		.con-img-upload{
			height: 100%;
		}
		.con-upload{
			height: 100%;
		}
		img {
			max-width: 100%;
			margin: 0 auto;
			width: 100%;
			height: 100%;
		}
	}

	.info {
		width: 170px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}
</style>
